export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurücksetzen"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alles auswählen"])}
}